// import { runWithAdal, AuthenticationContext, AdalConfig, adalGetToken } from 'react-adal';
// import azureAdConfig from './config/azure-ad.json';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@digital/ui/assets/css/main.css';
import '../public/main.css';
import '../public/mrn.css';

import 'moment/locale/pt-br';
import moment from 'moment';

moment.locale('pt-br', {
    week: {
        dow: 1 /// Date offset
    }
});

// import { setGraphJwt, setConnectorJwt } from './helpers';

(async () => {
  ReactDOM.render(<App />, document.getElementById("root"));
})();